import { Reveal } from "@/components/site/Reveal";
import { CONTACT } from "@/lib/content";
import { Heart, HandHeart, Stethoscope, Cookie } from "lucide-react";

const NEEDS = [
  { icon: Stethoscope, label: "Tierarztkosten" },
  { icon: Cookie, label: "Futter & Medikamente" },
  { icon: HandHeart, label: "Umbau der Station" },
];

export default function Spenden() {
  return (
    <section
      id="spenden"
      data-testid="section-spenden"
      className="relative py-20 md:py-32 bg-cream-alt"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <Reveal className="relative overflow-hidden rounded-[2.5rem] bg-brand-green p-10 md:p-16 shadow-card">
          <Heart
            className="absolute -right-8 -bottom-8 w-56 h-56 text-white/10"
            fill="currentColor"
          />
          <div className="relative max-w-2xl">
            <span className="font-accent text-3xl md:text-4xl text-white/90">
              Danke von Herzen
            </span>
            <h2 className="mt-2 font-heading font-extrabold text-white text-3xl md:text-4xl lg:text-5xl tracking-tight">
              Meine Igelstation braucht deine Unterstützung
            </h2>
            <p className="mt-5 text-lg md:text-xl leading-relaxed text-white/90">
              Meine Arbeit ist rein privat und wird ausschließlich durch Spenden
              finanziert. Jeder Euro hilft, damit ich weiter für die Igel da sein
              kann.
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              {NEEDS.map((n) => (
                <span
                  key={n.label}
                  className="inline-flex items-center gap-2 rounded-full bg-white/15 px-5 py-2.5 text-white font-medium"
                >
                  <n.icon className="w-5 h-5" /> {n.label}
                </span>
              ))}
            </div>

            <div className="mt-9 flex flex-col sm:flex-row sm:items-stretch gap-4">
              <div
                data-testid="spenden-paypal-info"
                className="inline-flex flex-wrap items-center gap-x-2 gap-y-1 rounded-2xl bg-white px-6 py-4 text-brand-green font-bold shadow-soft"
              >
                <span className="inline-flex items-center gap-2">
                  <Heart className="w-5 h-5" fill="#6B9071" /> PayPal:
                </span>
                <span className="break-all">{CONTACT.paypalEmail}</span>
              </div>
              <a
                href={CONTACT.phoneHref}
                data-testid="spenden-cta-phone"
                className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-white/70 px-8 py-4 text-white text-lg font-semibold transition-all duration-300 hover:bg-white hover:text-brand-green"
              >
                {CONTACT.phone}
              </a>
            </div>
            <p className="mt-5 text-sm text-white/70">
              Sende deine Spende einfach per PayPal an die oben genannte
              E-Mail-Adresse – jeder Euro hilft den Igeln.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
